import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\LandingPageController::create
* @see app/Http/Controllers/Admin/LandingPageController.php:45
* @route '/app/admin/landing-pages/create'
*/
export const create = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

create.definition = {
    methods: ["get","head"],
    url: '/app/admin/landing-pages/create',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\LandingPageController::create
* @see app/Http/Controllers/Admin/LandingPageController.php:45
* @route '/app/admin/landing-pages/create'
*/
create.url = (options?: RouteQueryOptions) => {
    return create.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\LandingPageController::create
* @see app/Http/Controllers/Admin/LandingPageController.php:45
* @route '/app/admin/landing-pages/create'
*/
create.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\LandingPageController::create
* @see app/Http/Controllers/Admin/LandingPageController.php:45
* @route '/app/admin/landing-pages/create'
*/
create.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: create.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\LandingPageController::create
* @see app/Http/Controllers/Admin/LandingPageController.php:45
* @route '/app/admin/landing-pages/create'
*/
const createForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\LandingPageController::create
* @see app/Http/Controllers/Admin/LandingPageController.php:45
* @route '/app/admin/landing-pages/create'
*/
createForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\LandingPageController::create
* @see app/Http/Controllers/Admin/LandingPageController.php:45
* @route '/app/admin/landing-pages/create'
*/
createForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

create.form = createForm

/**
* @see \App\Http\Controllers\Admin\LandingPageController::store
* @see app/Http/Controllers/Admin/LandingPageController.php:114
* @route '/app/admin/landing-pages'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/app/admin/landing-pages',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\LandingPageController::store
* @see app/Http/Controllers/Admin/LandingPageController.php:114
* @route '/app/admin/landing-pages'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\LandingPageController::store
* @see app/Http/Controllers/Admin/LandingPageController.php:114
* @route '/app/admin/landing-pages'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\LandingPageController::store
* @see app/Http/Controllers/Admin/LandingPageController.php:114
* @route '/app/admin/landing-pages'
*/
const storeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\LandingPageController::store
* @see app/Http/Controllers/Admin/LandingPageController.php:114
* @route '/app/admin/landing-pages'
*/
storeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

store.form = storeForm

/**
* @see \App\Http\Controllers\Admin\LandingPageController::generate
* @see app/Http/Controllers/Admin/LandingPageController.php:212
* @route '/app/admin/landing-pages/generate'
*/
export const generate = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: generate.url(options),
    method: 'post',
})

generate.definition = {
    methods: ["post"],
    url: '/app/admin/landing-pages/generate',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\LandingPageController::generate
* @see app/Http/Controllers/Admin/LandingPageController.php:212
* @route '/app/admin/landing-pages/generate'
*/
generate.url = (options?: RouteQueryOptions) => {
    return generate.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\LandingPageController::generate
* @see app/Http/Controllers/Admin/LandingPageController.php:212
* @route '/app/admin/landing-pages/generate'
*/
generate.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: generate.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\LandingPageController::generate
* @see app/Http/Controllers/Admin/LandingPageController.php:212
* @route '/app/admin/landing-pages/generate'
*/
const generateForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: generate.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\LandingPageController::generate
* @see app/Http/Controllers/Admin/LandingPageController.php:212
* @route '/app/admin/landing-pages/generate'
*/
generateForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: generate.url(options),
    method: 'post',
})

generate.form = generateForm

/**
* @see \App\Http\Controllers\Admin\LandingPageController::show
* @see app/Http/Controllers/Admin/LandingPageController.php:72
* @route '/app/admin/landing-pages/{landingPage}'
*/
export const show = (args: { landingPage: string | { uuid: string } } | [landingPage: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: '/app/admin/landing-pages/{landingPage}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\LandingPageController::show
* @see app/Http/Controllers/Admin/LandingPageController.php:72
* @route '/app/admin/landing-pages/{landingPage}'
*/
show.url = (args: { landingPage: string | { uuid: string } } | [landingPage: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { landingPage: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'uuid' in args) {
        args = { landingPage: args.uuid }
    }

    if (Array.isArray(args)) {
        args = {
            landingPage: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        landingPage: typeof args.landingPage === 'object'
        ? args.landingPage.uuid
        : args.landingPage,
    }

    return show.definition.url
            .replace('{landingPage}', parsedArgs.landingPage.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\LandingPageController::show
* @see app/Http/Controllers/Admin/LandingPageController.php:72
* @route '/app/admin/landing-pages/{landingPage}'
*/
show.get = (args: { landingPage: string | { uuid: string } } | [landingPage: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\LandingPageController::show
* @see app/Http/Controllers/Admin/LandingPageController.php:72
* @route '/app/admin/landing-pages/{landingPage}'
*/
show.head = (args: { landingPage: string | { uuid: string } } | [landingPage: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\LandingPageController::show
* @see app/Http/Controllers/Admin/LandingPageController.php:72
* @route '/app/admin/landing-pages/{landingPage}'
*/
const showForm = (args: { landingPage: string | { uuid: string } } | [landingPage: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\LandingPageController::show
* @see app/Http/Controllers/Admin/LandingPageController.php:72
* @route '/app/admin/landing-pages/{landingPage}'
*/
showForm.get = (args: { landingPage: string | { uuid: string } } | [landingPage: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\LandingPageController::show
* @see app/Http/Controllers/Admin/LandingPageController.php:72
* @route '/app/admin/landing-pages/{landingPage}'
*/
showForm.head = (args: { landingPage: string | { uuid: string } } | [landingPage: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

show.form = showForm

/**
* @see \App\Http\Controllers\Admin\LandingPageController::update
* @see app/Http/Controllers/Admin/LandingPageController.php:125
* @route '/app/admin/landing-pages/{landingPage}'
*/
export const update = (args: { landingPage: string | { uuid: string } } | [landingPage: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

update.definition = {
    methods: ["put"],
    url: '/app/admin/landing-pages/{landingPage}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Admin\LandingPageController::update
* @see app/Http/Controllers/Admin/LandingPageController.php:125
* @route '/app/admin/landing-pages/{landingPage}'
*/
update.url = (args: { landingPage: string | { uuid: string } } | [landingPage: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { landingPage: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'uuid' in args) {
        args = { landingPage: args.uuid }
    }

    if (Array.isArray(args)) {
        args = {
            landingPage: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        landingPage: typeof args.landingPage === 'object'
        ? args.landingPage.uuid
        : args.landingPage,
    }

    return update.definition.url
            .replace('{landingPage}', parsedArgs.landingPage.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\LandingPageController::update
* @see app/Http/Controllers/Admin/LandingPageController.php:125
* @route '/app/admin/landing-pages/{landingPage}'
*/
update.put = (args: { landingPage: string | { uuid: string } } | [landingPage: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Admin\LandingPageController::update
* @see app/Http/Controllers/Admin/LandingPageController.php:125
* @route '/app/admin/landing-pages/{landingPage}'
*/
const updateForm = (args: { landingPage: string | { uuid: string } } | [landingPage: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\LandingPageController::update
* @see app/Http/Controllers/Admin/LandingPageController.php:125
* @route '/app/admin/landing-pages/{landingPage}'
*/
updateForm.put = (args: { landingPage: string | { uuid: string } } | [landingPage: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

update.form = updateForm

/**
* @see \App\Http\Controllers\Admin\LandingPageController::translate
* @see app/Http/Controllers/Admin/LandingPageController.php:136
* @route '/app/admin/landing-pages/{landingPage}/translate'
*/
export const translate = (args: { landingPage: string | { uuid: string } } | [landingPage: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: translate.url(args, options),
    method: 'post',
})

translate.definition = {
    methods: ["post"],
    url: '/app/admin/landing-pages/{landingPage}/translate',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\LandingPageController::translate
* @see app/Http/Controllers/Admin/LandingPageController.php:136
* @route '/app/admin/landing-pages/{landingPage}/translate'
*/
translate.url = (args: { landingPage: string | { uuid: string } } | [landingPage: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { landingPage: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'uuid' in args) {
        args = { landingPage: args.uuid }
    }

    if (Array.isArray(args)) {
        args = {
            landingPage: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        landingPage: typeof args.landingPage === 'object'
        ? args.landingPage.uuid
        : args.landingPage,
    }

    return translate.definition.url
            .replace('{landingPage}', parsedArgs.landingPage.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\LandingPageController::translate
* @see app/Http/Controllers/Admin/LandingPageController.php:136
* @route '/app/admin/landing-pages/{landingPage}/translate'
*/
translate.post = (args: { landingPage: string | { uuid: string } } | [landingPage: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: translate.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\LandingPageController::translate
* @see app/Http/Controllers/Admin/LandingPageController.php:136
* @route '/app/admin/landing-pages/{landingPage}/translate'
*/
const translateForm = (args: { landingPage: string | { uuid: string } } | [landingPage: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: translate.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\LandingPageController::translate
* @see app/Http/Controllers/Admin/LandingPageController.php:136
* @route '/app/admin/landing-pages/{landingPage}/translate'
*/
translateForm.post = (args: { landingPage: string | { uuid: string } } | [landingPage: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: translate.url(args, options),
    method: 'post',
})

translate.form = translateForm

/**
* @see \App\Http\Controllers\Admin\LandingPageController::destroy
* @see app/Http/Controllers/Admin/LandingPageController.php:250
* @route '/app/admin/landing-pages/{landingPage}'
*/
export const destroy = (args: { landingPage: string | { uuid: string } } | [landingPage: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/app/admin/landing-pages/{landingPage}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Admin\LandingPageController::destroy
* @see app/Http/Controllers/Admin/LandingPageController.php:250
* @route '/app/admin/landing-pages/{landingPage}'
*/
destroy.url = (args: { landingPage: string | { uuid: string } } | [landingPage: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { landingPage: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'uuid' in args) {
        args = { landingPage: args.uuid }
    }

    if (Array.isArray(args)) {
        args = {
            landingPage: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        landingPage: typeof args.landingPage === 'object'
        ? args.landingPage.uuid
        : args.landingPage,
    }

    return destroy.definition.url
            .replace('{landingPage}', parsedArgs.landingPage.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\LandingPageController::destroy
* @see app/Http/Controllers/Admin/LandingPageController.php:250
* @route '/app/admin/landing-pages/{landingPage}'
*/
destroy.delete = (args: { landingPage: string | { uuid: string } } | [landingPage: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Admin\LandingPageController::destroy
* @see app/Http/Controllers/Admin/LandingPageController.php:250
* @route '/app/admin/landing-pages/{landingPage}'
*/
const destroyForm = (args: { landingPage: string | { uuid: string } } | [landingPage: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\LandingPageController::destroy
* @see app/Http/Controllers/Admin/LandingPageController.php:250
* @route '/app/admin/landing-pages/{landingPage}'
*/
destroyForm.delete = (args: { landingPage: string | { uuid: string } } | [landingPage: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

const landingPages = {
    create: Object.assign(create, create),
    store: Object.assign(store, store),
    generate: Object.assign(generate, generate),
    show: Object.assign(show, show),
    update: Object.assign(update, update),
    translate: Object.assign(translate, translate),
    destroy: Object.assign(destroy, destroy),
}

export default landingPages